import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sidemenu from '../../components/sidemenu';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Modal from '../../components/modal';
import Loader from '../../components/loader';
import Pagination from '../../components/pagination';
import Dropdown from '../../components/elements/dropdown01';
import RadioButton from '../../components/elements/radioButton01';
import * as Styled from './styled';

// import search from '../../images/search.svg';
import uploadIcon from '../../images/upload.svg';
import editIcon from '../../images/edit.svg';
import deleteIcon from '../../images/delete.svg';
// import publicIcon from '../../images/eye.svg';

import { filterRequest, questionRequest } from '../assessmentQuestion/actions';
import { ownerRequest } from '../addAssessmentQuestion/actions';
import { addRequest, getRequest, addClear } from './actions';

import axios from "axios";
class AddAssessmentTest extends Component {
  constructor (props) {
    super(props)
    this.state = {
      pageMode: '',
      page: 1,
      loading:false,
      removeBtn:true,
      entries: 10,
      addLevels: [
        { "name": "Test Details", "status": 2 },
        { "name": "Add Questions", "status": 1 },
        { "name": "Advance Settings", "status": 1 },
        { "name": "Publish", "status": 1 }
      ],
      difficulty: [
        { id: 'EASY', title: 'Easy' },
        { id: 'MEDIUM', title: 'Medium' },
        { id: 'HARD', title: 'Hard' },
      ],
      ownerTypes: [
        { id: 'COFFEEE', title: 'Coffeee' },
        { id: 'BOOTCAMP', title: 'Bootcamp' },
        { id: 'RECRUITER', title: 'Recruiter' },
        { id: 'COFFEEEPLUS', title: 'Coffeee Plus' },
        { id: 'CONTESTPLUS', title: 'Contest Plus' },
        { id: 'CAMPAIGN', title: 'campaign' },
        { id: 'COFFEEEPLUS', title: 'Coffeee Plus' },
        { id: 'CONTESTPLUS', title: 'Contest Plus' },
        { id: 'PRACTICE', title: 'Practice' },

      ],
      owners: [
        { id: 'COFFEEE', title: 'Coffeee' },
        { id: 'BOOTCAMP', title: 'Bootcamp' },
        { id: 'RECRUITER', title: 'Recruiter' },
        { id: 'CAMPAIGN', title: 'campaign' },
        { id: 'COFFEEEPLUS', title: 'Coffeee Plus' },
        { id: 'CONTESTPLUS', title: 'Contest Plus' },
      ],
      assessmentType: [
        {id: 'GENERAL', title:'General (MCQ, Coding & Mock)'},
        { id: "MCQ & Coding", title: "MCQ & Coding"},
        { id: "Mock Interview", title: "Mock Interview" },
        { id: "System Design", title: "System Design" },
        { id: "Project Assessment", title: "Project Assessment" },
        { id: "Expert Interview", title: "Expert Interview" }
      ]
    }
  }
  

  UNSAFE_componentWillMount() {
    let pageMode = 'add';

    if (window && window.location && window.location.pathname) {
      const pathArr = window.location.pathname.split('/');
      if (typeof pathArr[3] !== 'undefined' && pathArr[3] !== '') {
        this.props.getRequest(pathArr[3]);
        pageMode = pathArr[2];
      }
    }
    this.resetInput();
    this.props.filterRequest();
    this.setState({ pageMode });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.addAssessmentTest) {

      if (nextProps.addAssessmentTest.addTest
        && nextProps.addAssessmentTest.addTest.code === 200) {
        window.location = '/assessment-test';
      }

      if (this.state.pageMode === 'edit'
      && this.state.test
      && typeof this.state.test.test_id === 'undefined'
      && nextProps.addAssessmentTest.getTest
      && nextProps.addAssessmentTest.getTest.data
      && nextProps.addAssessmentTest.getTest.data[0]) {
        const t = nextProps.addAssessmentTest.getTest.data[0];
        const test = this.state.test;
        let pooledQuestionData = this.state.pooledQuestionData;
        let manualQuestionData = this.state.manualQuestionData;

        test.test_id = t.test_id;
        test.test_title = t.test_title;
        test.test_description = t.test_desc;
        test.test_cover_url = t.test_cover_img;
        test.test_icon_img = t.test_icon_img;
        test.group_id = t.group_id;
        test.master_skill_id = t.master_skill_id;
        test.category_name = t.category_name;
        test.instruction_id = t.instruction_id;
        test.instruction_text = t.instruction_text;
        test.difficulty_level = t.difficulty_level;
        test.duration = t.duration;
        test.total_questions = t.total_questions;
        test.total_marks = t.total_marks;
        test.test_type = t.test_type;
        test.candidate_email = t.candidate_email ? t.candidate_email.join(', ') : '';
        test.start_date = t.start_date ? t.start_date.split('T')[0] : '';
        test.expiry_date = t.expiry_date ? t.expiry_date.split('T')[0] : '';
        test.attempt_all = t.attempt_all;
        test.hop_question = t.hop_question;
        test.multiple_attempt = t.multiple_attempt;
        test.max_attempt = t.max_attempt;
        test.shuffle = t.shuffle;
        test.fullscreen = t.full_screen;
        test.live_screen_capture = t.live_screen_capture;
        test.mic_check = t.mic_check;
        test.location_check = t.location_check;
        test.alter_msg = t.alter_msg;
        test.is_pooled = t.is_pooled;
        test.is_bootcamp = t.is_bootcamp || false;
        test.assessment_type = t.assessment_type;
        test.group_id = t.group_id;

        const addQuestion = this.state.addQuestion;
        addQuestion.is_bootcamp = t.is_bootcamp;

        // const filters = this.state.filters;

        if (t.owners) {
          const ownerName = t.owners.split('_');
          if (ownerName[0] === 'BOOTCAMP' || ownerName[0] === 'RECRUITER') {
            test.owners = ownerName[0];
            test.owners_id = ownerName[1] ? ownerName[1] : '';
            // filters.owners = ownerName[0];
            nextProps.ownerRequest(ownerName[0]);
          } else {
            test.owners = ownerName[0];
            test.owners_id = '';
            // filters.owners = 'COFFEEE';
          }
        }

        if (t.is_pooled === true) {
          pooledQuestionData = t.question_data ? t.question_data : [];
        } else {
          manualQuestionData = t.question_data ? t.question_data : [];
        }


        let defaultLanguages = this.state.defaultLanguages;

        if (t.default_language !== null) {
          let responseDefaultLang = t.default_language;

          responseDefaultLang.sort((t, o) => t.id - o.id);
          defaultLanguages.sort((t, o) => t.id - o.id);

          let i = 0; let j = 0;
          while (i < defaultLanguages.length) {
            if (j < responseDefaultLang.length && defaultLanguages[i].id === JSON.parse(responseDefaultLang[j]).id) {
              defaultLanguages[i].selected = true;
              j++;
            } else {
              defaultLanguages[i].selected = false;
            }
            i++;
          }

        }

        this.setState({ test, pooledQuestionData, manualQuestionData, addQuestion, defaultLanguages });
      }
    }
  }

  componentWillUnmount() {
    this.props.addClear();
    this.resetInput();
  }

  resetInput = () => {
    this.setState({
      level: 0,
      activeEdit: null,
      poolModalToggle: false,
      editPoolIndex: null,
      filters: {},
      newItem: {
        category: false,
        instruction: false,
      },
      test: {
        test_title: '',
        group_id: '',
        test_description: '',
        test_cover_url: '',
        test_icon_img:'',
        master_skill_id: '',
        category_name: '',
        cover_image: null,
        cover_logo:null,
        new_category: '',
        instruction_id: '',
        instruction_text: '',
        new_instruction: '',
        difficulty_level: '',
        duration: '',
        total_questions: '',
        total_marks: '',
        test_type: "PUBLIC",
        candidate_email: '',
        start_date: '',
        expiry_date: '',
        attempt_all: false,
        hop_question: false,
        multiple_attempt: false,
        max_attempt: '3',
        shuffle: false,
        fullscreen: false,
        live_screen_capture: false,
        mic_check: false,
        location_check: false,
        alter_msg: false,
        is_pooled: false,
        is_bootcamp: false,
        owners: 'COFFEEE',
        owners_id: '',
        assessment_type: '',
        group_id: '',
      },
      error: {
        test_title: '',
        group_id: '',
        test_description: '',
        assessment_type: '',
        test_cover_url: '',
        test_icon_img:'',
        master_skill_id: '',
        category_name: '',
        cover_image: '',
        cover_logo:'',
        new_category: '',
        instruction_id: '',
        instruction_text: '',
        new_instruction: '',
        difficulty_level: '',
        duration: '',
        total_questions: '',
        total_marks: '',
        candidate_email: '',
        start_date: '',
        expiry_date: '',
        max_attempt: '',
        saveError: '',
        owners_id: '',
        group_id: '',
      },
      pooledQuestionData: [],
      manualQuestionData: [],
      addQuestion: {
        master_skill_id: '',
        category_name: '',
        topic_id: '',
        topic_name: '',
        question_type_id: '',
        question_type_name: '',
        question_type_code:"",
        question_count: '',
        difficulty_level: '',
        marks_per_question: '',
        random: false,
        is_bootcamp: false,
        owners: '',
      },
      errorAddQuestion: {
        master_skill_id: '',
        topic_id: '',
        question_type_id: '',
        difficulty_level: '',
        question_count: '',
        marks_per_question: '',
        same_question: '',
        owners:'',
      },
      defaultLanguages: [
        {
          "id": 49,
          "name": "C (GCC 8.3.0)",
          "languageCode":"C",
          "selected": true
        },
        {
          "id": 53,
          "name": "C++ (GCC 8.3.0)",
          "languageCode":"C++",
          "selected": true
        },
        {
          "id": 60,
          "name": "Go (1.13.5)",
          "languageCode":"Go",
          "selected": true
        },
        {
          "id": 62,
          "name": "Java (OpenJDK 13.0.1)",
          "languageCode":"Java",
          "selected": true
        },
        {
          "id": 63,
          "name": "JavaScript (Node.js 12.14.0)",
          "languageCode":"Javascript",
          "selected": true
        },
        {
          "id": 71,
          "name": "Python (3.8.1)",
          "languageCode":"Python",
          "selected": true
        },
        {
          "id": 72,
          "name": "Ruby (2.7.0)",
          "languageCode":"Ruby",
          "selected": true
        },
        {
          "id": 68,
          "name": "PHP (7.4.1)",
          "languageCode":"PHP",
          "selected": true
        },
        {
          "id": 51,
          "name": "C# (Mono 6.6.0.161)",
          "languageCode": "C#",
          "selected": true
        }
      ]
    })
  }

  changeLevel = (mode, l) => {
    let level = '';
    const addLevels = this.state.addLevels;

    if (mode === 'to') {
      level = l;
    } else {
      level = this.state.level;
      if (mode === 'back') {
        if (level > 0) level -= 1;
      } else {
        if (level < addLevels.length - 1) level += 1;
      }
    }

    for (let x = 0; x < addLevels.length; x++) {
      if (x === level) addLevels[x].status = 2;
      else if (x < level) addLevels[x].status = 3;
      else if (x > level) addLevels[x].status = 1;
    }

    this.setState({ level, addLevels });
  }

  saveAndProceed = () => {
    const { level, test, newItem, pooledQuestionData, manualQuestionData } = this.state;
    const error = this.state.error;
    const { filter } = this.props.assessmentQuestion;
    let isValid = true;
    const candidateEmails = [];

    function isInvalid(key, value) {
      error[key] = value;
      isValid = false;
    }

    function isEmpty(val) {
      if (val && typeof val === 'string' && val.trim() !== '') return false;
      else if (val) return false;
      else return true;
    }

    function validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    if (level > -1) {
      if (isEmpty(test.test_title)) isInvalid('test_title', 'Please enter test title');
      if (isEmpty(test.test_description)) isInvalid('test_description', 'Please enter test description');
      if (isEmpty(test.duration)) isInvalid('duration', 'Please enter duration');
      if (isEmpty(test.difficulty_level)) isInvalid('difficulty_level', 'Please select difficulty');
      if (isEmpty(test.total_questions)) isInvalid('total_questions', 'Please enter total questions');
      if (isEmpty(test.total_marks)) isInvalid('total_marks', 'Please enter total marks');
      if ((test.owners === 'BOOTCAMP' || test.owners === 'RECRUITER') && test.owners_id === '') {
        isInvalid('owners_id', `Please select ${test.owners}`)
      }

      if (newItem.category === true) {
        if (isEmpty(test.new_category)) {
          isInvalid('new_category', 'Please enter new category');
        } else if (filter && filter.category && filter.category.length > 0) {
          for (let x = 0; x < filter.category.length; x++) {
            if (filter.category[x] && filter.category[x].category_name && filter.category[x].category_name.trim().toLowerCase() === test.new_category.trim().toLowerCase()) {
              isInvalid('new_category', 'New category already exist');
            }
          }
        }
      } else {
        if (isEmpty(test.master_skill_id)) isInvalid('master_skill_id', 'Please select category');
      }
      if (newItem.instruction === true) {
        if (isEmpty(test.new_instruction)) {
          isInvalid('new_instruction', 'Please enter new instruction');
        } else if (filter && filter.instruction && filter.instruction.length > 0) {
          for (let x = 0; x < filter.instruction.length; x++) {
            if (filter.instruction[x] && filter.instruction[x].instruction && filter.instruction[x].instruction.trim().toLowerCase() === test.new_instruction.trim().toLowerCase()) {
              isInvalid('new_instruction', 'New instruction already exist');
            }
          }
        }
      } else {
        if (isEmpty(test.instruction_id)) isInvalid('instruction_id', 'Please select instruction');
      }
      if (isValid === false) {
        this.changeLevel('to', 0);
        return;
      }
    }

    if (level > 0) {
      let totalQuestions = 0;
      let totalMarks = 0;
      if (test.is_pooled === true) {
        if (pooledQuestionData && pooledQuestionData.length < 1) {
          isInvalid('saveError', 'Please add questions before proceed');
        } else {
          totalQuestions = pooledQuestionData.reduce((m, item) => m + item['question_count'], 0);
          totalMarks = pooledQuestionData.reduce((m, item) => m + (item['marks_per_question'] * item['question_count']), 0);
          if (test.total_questions !== totalQuestions || test.total_marks !== totalMarks) {
            isInvalid('saveError', `Please add ${test.total_questions} questions of ${test.total_marks} marks to proceed`);
          }
        }
      } else {
        if (manualQuestionData && manualQuestionData.length < 1 ) {
          isInvalid('saveError', 'Please add questions before proceed');
        } else {
          totalQuestions = manualQuestionData.length;
          totalMarks = manualQuestionData.reduce((m, item) => m + item['marks'], 0);
          if (test.total_questions !== totalQuestions || test.total_marks !== totalMarks) {
            isInvalid('saveError', `Please add ${test.total_questions} questions of ${test.total_marks} marks to proceed`);
          }
        }
      }
    }

    if (level > 1) {
      if (test.multiple_attempt === true && isEmpty(test.max_attempt)) isInvalid('max_attempt', 'Please enter max attempt');
      if (isValid === false) {
        this.changeLevel('to', 2);
        return;
      }
    }

    if (level > 2) {
      if (isEmpty(test.start_date)) isInvalid('start_date', 'Please enter start data');
      if (isEmpty(test.expiry_date)) isInvalid('expiry_date', 'Please enter expity date');
      if (test.test_type === 'PRIVATE') {
        if (isEmpty(test.candidate_email)) {
          isInvalid('candidate_email', 'Please enter candidates email');
        } else {
          const emailArr = test.candidate_email ? test.candidate_email.split(',') : [];
          for (let x = 0; x < emailArr.length; x++) {
            const e_mail = emailArr[x].trim();
            if (validateEmail(e_mail)) {
              candidateEmails.push(e_mail);
            } else {
              isInvalid('candidate_email', 'Please enter valid email');
              break;
            }
          }
        }
      }
      if (isValid === false) {
        this.changeLevel('to', 3);
        return;
      }
    }

    if (isValid === true) {
      if (level < 3) {
        if (level === 0 && test.is_pooled === false) {
          this.props.questionRequest(this.renameDifficulty());
        }
        this.changeLevel();
      } else {
        if (newItem.category === true) {
          test.category_name = test.new_category;
          test.master_skill_id = null;
        }
        if (newItem.instruction === true) {
          test.instruction_text = test.new_instruction;
          test.instruction_id = null;
        }

        delete test.new_category;
        delete test.new_instruction;

        test.test_question_data = test.is_pooled ? pooledQuestionData : manualQuestionData;
        test.candidate_email = candidateEmails;

        if (test.owners === 'BOOTCAMP' || test.owners === 'RECRUITER') {
          test.owners = `${test.owners}_${test.owners_id}`;
        } else if(test.owners==='CAMPAIGN'){
          test.owners = `${test.owners}_${test.difficulty_level}`;
        }
        delete test.owners_id;

        const default_language = [];
        const defaultLanguages = this.state.defaultLanguages;
        for (let i = 0; i < defaultLanguages.length; i++) {
          if (defaultLanguages[i]['selected']) {
            default_language.push({
              "id": defaultLanguages[i]["id"],
              "name": defaultLanguages[i]["name"],
              "languageCode": defaultLanguages[i]["languageCode"]
            })
          }
        }

        if (default_language.length === 0) {
          for (let i = 0; i < defaultLanguages.length; i++) {
            default_language.push({
              "id": defaultLanguages[i]["id"],
              "name": defaultLanguages[i]["name"],
              "languageCode": defaultLanguages[i]["languageCode"]
            })
          }
        }

        test.default_language = default_language;
        this.props.addRequest(test, this.state.pageMode);
      }
    } else {
      this.setState({ error });
    }
  }

  cancelManualEdit = () => {
    this.setState({ activeEdit: null })
  }

  editManualQuestion = (activeEdit, marks) => {
    const manualMarks = marks;
    this.setState({ activeEdit, manualMarks });
  }

  changeManualMarks = (e) => {
    const value = e.target.value;
    const isnum = /^\d+$/.test(value);
    if (isnum === true || value === '') {
      const manualMarks = value !== '' ? parseInt(value, 10) : '';
      this.setState({ manualMarks });
      this.removeError('saveError');
    }
  }

  deleteManauQuestion = (index) => {
    const manualQuestionData = this.state.manualQuestionData;
    manualQuestionData.splice(index, 1);
    this.setState({ manualQuestionData });
    this.removeError('saveError');
  }

  updateManualMarks = (index) => {
    const manualQuestionData = this.state.manualQuestionData;
    let manualMarks = this.state.manualMarks;
    if (manualMarks === 0 || manualMarks === '') {
      manualMarks = 1;
    }
    manualQuestionData[index].marks = manualMarks;
    this.setState({ manualQuestionData, activeEdit: null });
    this.removeError('saveError');
  }

  removeError = (key) => {
    const error = this.state.error;
    error[key] = '';
    this.setState({ error });
  }

  addNewItem = (val) => {
    const newItem = this.state.newItem;
    newItem[val] = !newItem[val];
    this.setState({ newItem })

    if (val === 'category') {
      this.removeError('master_skill_id');
      this.removeError('new_category');
    } else if (val === 'instruction') {
      const test = this.state.test;
      const instructionText = test.instruction_text;
      test.new_instruction = instructionText;
      // test.instruction_text = '';
      // test.instruction_id = '';
      this.setState({ test });
      this.removeError('instruction_id');
      this.removeError('new_instruction');
    }
  }

  dropdownChange = (id, name) => {
    const test = this.state.test;
    const error = this.state.error;

    if (typeof id !== 'undefined' && id !== null && id !== '') {
      test[name] = id;
      error[name] = '';
    }

    const filterLoop = (name, id, title) => {
      if (this.props.assessmentQuestion && this.props.assessmentQuestion.filter) {
        const filter = this.props.assessmentQuestion.filter;
        if (filter && filter[name] && filter[name].length > 0) {
          for (let x = 0; x < filter[name].length; x+= 1) {
            if (filter[name][x].id === id) return filter[name][x][title];
          }
        }
      }
    }

    if (name === 'master_skill_id') test.category_name = filterLoop('category', id, 'category_name')
    else if (name === 'instruction_id') test.instruction_text = filterLoop('instruction', id, 'instruction')
    this.setState({ test, error });
  }

  inputChange = (e, type) => {
    const { id, value } = e.target;
    const test = this.state.test;
    const error = this.state.error;
    if (type === 'digit') {
      const isnum = /^\d+$/.test(value);
      if (isnum === true || value === '') {
        test[id] = value !== '' ? parseInt(value, 10) : '';
        if (typeof error[id] !== 'undefined') error[id] = '';
      }
    } else {
      test[id] = value;
      if (id === 'start_date' && test.expiry_date !== '' && test.start_date > test.expiry_date) {
        test.expiry_date = '';
      }
      if (typeof error[id] !== 'undefined') error[id] = '';
    }
    this.setState({ test, error });
  }

  checkboxChange = (e) => {
    const { id, checked } = e.target;
    const test = this.state.test;
    test[id] = checked;
    this.setState({ test });
  }

  openPoolModal = () => {
    this.setState({ poolModalToggle: true })
  }

  closePoolModal = () => {
    const addQuestion = {
      master_skill_id: '',
      category_name: '',
      topic_id: '',
      topic_name: '',
      question_type_id: '',
      question_type_name: '',
      question_type_code:"",
      question_count: '',
      difficulty_level: '',
      marks_per_question: '',
      random: false,
      owners: ''
    };
    const errorAddQuestion = {
      master_skill_id: '',
      topic_id: '',
      question_type_id: '',
      difficulty_level: '',
      question_count: '',
      marks_per_question: '',
      same_question: '',
      owners: ''
    };
    this.setState({ poolModalToggle: false, editPoolIndex: null, addQuestion, errorAddQuestion });
  }

  poolDropdownChange = (id, name) => {
    const addQuestion = this.state.addQuestion;
    const errorAddQuestion = this.state.errorAddQuestion;

    if (typeof id !== 'undefined' && id !== null && id !== '') {
      addQuestion[name] = id;
      errorAddQuestion[name] = '';
      errorAddQuestion['same_question'] = '';
    }

    const filterLoop = (name, id, title) => {
      if (this.props.assessmentQuestion && this.props.assessmentQuestion.filter) {
        const filter = this.props.assessmentQuestion.filter;
        if (filter && filter[name] && filter[name].length > 0) {
          for (let x = 0; x < filter[name].length; x+= 1) {
            if (filter[name][x].id === id) return filter[name][x][title];
          }
        }
      }
    }

    if (name === 'master_skill_id') addQuestion.category_name = filterLoop('category', id, 'category_name')
    else if (name === 'topic_id') addQuestion.topic_name = filterLoop('topic', id, 'topic_name')
    else if (name === 'question_type_id') addQuestion.question_type_name = filterLoop('question_type', id, 'question_type_name')
    if(filterLoop('question_type', id, 'question_type_name')){
      addQuestion.question_type_code=filterLoop('question_type', id, 'question_type_name')==='Compiler Question'?'COMPILER':filterLoop('question_type', id, 'question_type_name')==='Multiple Choice Question'?"MCQ":"MOCKINTERVIEW"
      if(filterLoop('question_type', id, 'question_type_name')==='Compiler Question'||filterLoop('question_type', id, 'question_type_name')==='Multiple Choice Question')
        this.setState({removeBtn: true})
      else
        this.setState({removeBtn: false});
    }

    this.setState({ addQuestion, errorAddQuestion });
    this.filterSelect(id, name);
  }

  poolInputChange = (e) => {
    const { id, value } = e.target;
    const addQuestion = this.state.addQuestion;
    const errorAddQuestion = this.state.errorAddQuestion;
    const isnum = /^\d+$/.test(value);
    if (isnum === true || value === '') {
      addQuestion[id] = value !== '' ? parseInt(value, 10) : '';
      if (typeof errorAddQuestion[id] !== 'undefined') errorAddQuestion[id] = '';
    }
    this.setState({ addQuestion, errorAddQuestion });
  }

  poolRandomSelect = () => {
    const addQuestion = this.state.addQuestion;
    addQuestion.random = !addQuestion.random;
    this.setState({ addQuestion });
  }

  addPoolQuestion = () => {
    const { master_skill_id, topic_id, question_type_id, question_count, difficulty_level, marks_per_question } = this.state.addQuestion;
    const { filter, questions } = this.props.assessmentQuestion;
    const errorAddQuestion = this.state.errorAddQuestion;
    const pooledQuestionData = this.state.pooledQuestionData;
    let isValid = true;

    function isInvalid(key, value) {
      errorAddQuestion[key] = value;
      isValid = false;
    }

    function isEmpty(val) {
      if (val && typeof val === 'string' && val.trim() !== '') return false;
      else if (val) return false;
      else return true;
    }
    if (isEmpty(master_skill_id)) isInvalid('master_skill_id', 'Please select category');
    if (isEmpty(topic_id)) isInvalid('topic_id', 'Please select topic');
    if (isEmpty(question_type_id)) isInvalid('question_type_id', 'Please select question type');
    if (isEmpty(question_count)) {
      isInvalid('question_count', 'Please enter question count');
    } else if (questions && question_count > questions.length) {
      errorAddQuestion['question_count'] = `${question_count} questions not available`;
      isValid = false;
    }
    if (isEmpty(difficulty_level)) isInvalid('difficulty_level', 'Please select difficulty');
    if (isEmpty(marks_per_question)) isInvalid('marks_per_question', 'Please enter marks');

    for (let i = 0; i < pooledQuestionData.length; i++) {
      if (i !== this.state.editPoolIndex
      && pooledQuestionData[i].master_skill_id === master_skill_id
      && pooledQuestionData[i].topic_id === topic_id
      && pooledQuestionData[i].question_type_id === question_type_id
      && pooledQuestionData[i].difficulty_level === difficulty_level) {
        errorAddQuestion['same_question'] = 'Questions type already added';
        isValid = false;
        break;
      }
    }

    if (isValid === true) {
      if (this.state.editPoolIndex !== null) {
        pooledQuestionData[this.state.editPoolIndex] = this.state.addQuestion;
      } else {
        pooledQuestionData.push(this.state.addQuestion);
      }
      this.closePoolModal();
      this.removeError('saveError');
    } else {
      this.setState({ errorAddQuestion });
    }
  }
  generateQuestion=async(difficulty_level,skill)=>{
    try {
      this.setState({loading:true});
      const resp = await axios
        .post(
            `${process.env.REACT_APP_WEB_API}/api/v1/assessments/generate-questions`,
            {
                difficulty_level: difficulty_level, skill: skill ,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem("jwtToken"),
                },
            }
        )
      this.setState({loading:false});
      this.props.questionRequest(this.renameDifficulty());

    } catch (error) {
      this.setState({loading:false});
      console.log("===========",error);
    }

  }

  deletePoolQuestion = (index) => {
    const pooledQuestionData = this.state.pooledQuestionData;
    pooledQuestionData.splice(index, 1);
    this.setState({ pooledQuestionData });
    this.removeError('saveError');
  }

  editPoolQuestion = (index) => {
    if (this.state.pooledQuestionData[index]) {
      const data = this.state.pooledQuestionData[index];
      const addQuestion = this.state.addQuestion;

      addQuestion.master_skill_id = data.master_skill_id;
      addQuestion.category_name = data.category_name;
      addQuestion.topic_id = data.topic_id;
      addQuestion.topic_name = data.topic_name;
      addQuestion.question_type_id = data.question_type_id;
      addQuestion.question_type_name = data.question_type_name;
      addQuestion.question_count = data.question_count;
      addQuestion.difficulty_level = data.difficulty_level;
      addQuestion.marks_per_question = data.marks_per_question;
      addQuestion.random = data.random;
      addQuestion.question_type_code=data.question_type_name==='Compiler Question'?'COMPILER':data.question_type_name==='Multiple Choice Question'?"MCQ":"MOCKINTERVIEW"

      this.setState({ addQuestion, poolModalToggle: true, editPoolIndex: index });
      this.removeError('saveError');
    }
  }

  filterSelect = (id, name) => {
    const filters = this.state.filters;
    if (typeof id !== 'undefined' && id !== null && id !== '') {
      filters[name] = id;
    } else {
      delete filters[name];
    }
    const {filter}=this.props.assessmentQuestion
    if(name==='question_type_id'){
      let value=filter.question_type.filter((i)=>i.id===id)
      if(value[0].question_type_name==='Compiler Question'||value[0].question_type_name==='Multiple Choice Question')
        this.setState({removeBtn:true})
      else
        this.setState({removeBtn:false})
    }
    this.props.questionRequest(this.renameDifficulty());
    this.setState({ filters });
  }

  renameDifficulty = () => {
    const filters = this.state.filters;
    if (filters.difficulty_level) {
      filters.difficulty_type = filters.difficulty_level;
      delete filters.difficulty_level;
    }
    return filters;
  }

  addManualQuestion = (id, title,question_type_code) => {
    const manualQuestionData = this.state.manualQuestionData;
    if (manualQuestionData) {
      manualQuestionData.push({ question_id: id, title: title, marks: 2,question_type_code:question_type_code });
      this.setState({ manualQuestionData });
      this.removeError('saveError');
    }
  }

  deleteManualQuestion = (id) => {
    const manualQuestionData = this.state.manualQuestionData;
    if (manualQuestionData) {
      for (let x = 0; x < manualQuestionData.length; x++) {
        if (manualQuestionData[x].question_id === id) manualQuestionData.splice(x, 1);
      }
      this.setState({ manualQuestionData });
      this.removeError('saveError');
    }
  }

  manualQuestionCheck = (id) => {
    const manualQuestionData = this.state.manualQuestionData;
    if (manualQuestionData) {
      for (let x = 0; x < manualQuestionData.length; x++) {
        if (manualQuestionData[x].question_id === id) return true;
      }
    }
    return false;
  }

  coverImageHandler = (e) => {
    const {test, error} = this.state;
    const image = e.target.files[0];
    const fileExtensionText = image.name.split('.');
    const fileExtension = fileExtensionText[fileExtensionText.length-1];
    if (fileExtension === 'png' || fileExtension === 'jpeg' || fileExtension === 'jpg') {
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        test.cover_image = fileReader.result;
        error.cover_image = '';
        this.setState({ error });
        this.setState({ test });

      }, false);
      fileReader.readAsDataURL(image);
    } else {
      error.cover_image = 'Upload File In Required Format!';
      test.cover_image = null;
      this.setState({ error });
      this.setState({ test });
    }
  }
  logoHandler = (e) => {
    const {test, error} = this.state;
    const image = e.target.files[0];
    const fileExtensionText = image.name.split('.');
    const fileExtension = fileExtensionText[fileExtensionText.length-1];
    if (fileExtension === 'png' || fileExtension === 'jpeg' || fileExtension === 'jpg' || fileExtension==='svg') {
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        test.cover_logo = fileReader.result;
        error.cover_logo = '';
        this.setState({ error });
        this.setState({ test });

      }, false);
      fileReader.readAsDataURL(image);
    } else {
      error.cover_logo = 'Upload File In Required Format!';
      test.cover_logo = null;
      this.setState({ error });
      this.setState({ test });
    }
  }
  paginationClick = (page) => {
    this.setState({ page })
  }

  ownerTypeChange = (id) => {
    let test = this.state.test;
    if (test.owners !== id) {
      // const filters = this.state.filters;
      // filters.owners = id;
      // filters.is_bootcamp = id === 'BOOTCAMP' ? true : false;

      const error = this.state.error;
      error.owners_id = '';

      test.owners = id;
      test.owners_id = '';
      test.is_bootcamp = id === 'BOOTCAMP' ? true : false;;

      if (id === 'BOOTCAMP' || id === 'RECRUITER') {
        this.props.ownerRequest(id);
      }
      this.setState({ test, error })
    }
  }

  handleDefaultLanguage = (e) => {
    const { checked, id } = e.target;
    const defaultLangArr = this.state.defaultLanguages;
    defaultLangArr[id].selected = checked;
    this.setState({ defaultLanguages: defaultLangArr })
  }
  render () {
    const { addLevels, level, error, newItem, difficulty, test, filters, activeEdit, pooledQuestionData, manualQuestionData, poolModalToggle, editPoolIndex, addQuestion, errorAddQuestion, pageMode, page, entries, ownerTypes, defaultLanguages, add_compiler_ques, assessmentType, groups } = this.state;
    const { filter, questions, questionsLoading } = this.props.assessmentQuestion;
    const { addTestLoading } = this.props.addAssessmentTest;
    const { owners } = this.props.addAssessmentQuestion;

    const saveWrap = [];
    if (level === 3) {
      saveWrap.push(
        <Styled.BackButton onClick={() => this.changeLevel('back')}>Back</Styled.BackButton>,
        <Styled.BackButton>Preview</Styled.BackButton>,
        <Styled.SaveButton onClick={this.saveAndProceed}>{ pageMode === 'edit' ? 'Update' : 'Publish'}</Styled.SaveButton>
      );
    } else if (level === 1) {
      saveWrap.push(<Styled.BackButton onClick={() => this.changeLevel('back')}>Back</Styled.BackButton>);
      if (test.is_pooled === true) {
        if (pooledQuestionData && pooledQuestionData.length > 0) {
          saveWrap.push(<Styled.SaveButton onClick={this.saveAndProceed}>Save &amp; Proceed</Styled.SaveButton>);
        }
      } else {
        saveWrap.push(<Styled.SaveButton onClick={this.saveAndProceed}>Save &amp; Proceed</Styled.SaveButton>);
      }
      saveWrap.push(<Styled.SaveErrorDiv>{error.saveError}</Styled.SaveErrorDiv>);
    } else {
      if (level === 0) saveWrap.push(<Styled.CancelLink to="/assessment-test">Back</Styled.CancelLink>);
      else saveWrap.push(<Styled.BackButton onClick={() => this.changeLevel('back')}>Back</Styled.BackButton>);
      saveWrap.push(<Styled.SaveButton onClick={this.saveAndProceed}>Save &amp; Proceed</Styled.SaveButton>);
    }

    let totalQuestions = 0;
    let totalMarks = 0;

    if (test.is_pooled === true) {
      if (pooledQuestionData.length > 0) {
        totalQuestions = pooledQuestionData.reduce((m, item) => m + item['question_count'], 0);
        totalMarks = pooledQuestionData.reduce((m, item) => m + (item['marks_per_question'] * item['question_count']), 0);
      }
    } else {
      totalQuestions = manualQuestionData.length;
      if (manualQuestionData.length > 0) {
        totalMarks = manualQuestionData.reduce((m, item) => m + item['marks'], 0)
      }
    }

    let heading = 'Test';
    if (pageMode !== '') {
      heading = pageMode === 'edit' ? 'Edit Test' : 'New Test';
    }

    return (
      <Styled.MainDiv>
        <Loader show={addTestLoading} heading={pageMode === 'edit' ? 'Updating Test' : 'Adding Test'} />
        <Sidemenu collapsed={this.state.sideMenuCollapsed} />
        <Styled.ColumnDiv>
          <Header />

          <Styled.ContentWrapDiv>
            <Styled.ContentDiv>
              <Styled.HeaderWrapDiv>
                <div>{heading}</div>
              </Styled.HeaderWrapDiv>

              <Styled.CardDiv>
                <Styled.LevelWrapDiv>
                  { addLevels.map((level, levelIndex) => {
                    let numStyle = {};
                    let textStyle = {};
                    if (level.status === 2) {
                      numStyle = { color: '#1B49EA', backgroundColor: '#EDF0FD', fontWeight: 'bold' };
                      textStyle = { fontWeight: 'bold' };
                    } else if (level.status === 3) {
                      numStyle = { color: '#21C17A', backgroundColor: '#cbf5e3', fontWeight: 'bold' };
                      textStyle = { color: '#21C17A' };
                    }
                    return (
                      <Styled.LevelDiv key={`testing_${levelIndex}`}>
                        <Styled.LevelNumDiv style={numStyle}>{levelIndex + 1}</Styled.LevelNumDiv>
                        <div style={textStyle}>{level.name}</div>
                      </Styled.LevelDiv>
                    )
                  }) }
                  <Styled.LevelActiveBarDiv style={{ width: `${(level > 5 ? 5 : level) * 160}px` }} />
                  <Styled.LevelBarDiv />
                </Styled.LevelWrapDiv>
                { level === 0 ?
                  <Styled.DetailsWrapDiv>
                    <Styled.InputWrap error={error.test_title !== ''}>
                      <Styled.InputTitleDiv>Test Title</Styled.InputTitleDiv>
                      <input type="text" id="test_title" placeholder="Enter Test Title" value={test.test_title} onChange={(e) => this.inputChange(e)} />
                      <Styled.InputErrorDiv>{error.test_title}</Styled.InputErrorDiv>
                    </Styled.InputWrap>

                    <Styled.InputWrap>
                        <Styled.InputTitleDiv>Group</Styled.InputTitleDiv>
                        <div style={{ display: 'flex' }}>
                          <Dropdown title="Select Group" list={filter?.group} value="id" name="group_id" selected={this.dropdownChange} width="600px" height="55px" option="name" active={test} error={error.group_id !== ''} />
                        </div>
                        <Styled.InputErrorDiv>{error.group_id}</Styled.InputErrorDiv>
                      </Styled.InputWrap>

                    <Styled.InputWrap error={error.test_description !== ''}>
                      <Styled.InputTitleDiv>Description</Styled.InputTitleDiv>
                      <textarea rows="8" id="test_description" placeholder="Enter description..." value={test.test_description} onChange={(e) => this.inputChange(e)} />
                      <Styled.InputErrorDiv>{error.test_description}</Styled.InputErrorDiv>
                    </Styled.InputWrap>

                    <Styled.InputWrap>
                        <Styled.InputTitleDiv>Assessment Type</Styled.InputTitleDiv>
                        <div style={{ display: 'flex' }}>
                          <Dropdown title="Select Assessment Type" list={assessmentType} value="id" name="assessment_type" selected={this.dropdownChange} width="600px" height="55px" option="title" active={test} error={error.assessment_type !== ''} />
                        </div>
                        <Styled.InputErrorDiv>{error.assessment_type}</Styled.InputErrorDiv>
                      </Styled.InputWrap>
                    
                    <Styled.InputWrap>
                      <Styled.InputTitleDiv>Cover Image</Styled.InputTitleDiv>
                      <Styled.CoverImageWrapDiv>
                        <div style={{ fontSize: '16px', marginBottom: '8px' }}>Upload Cover Image</div>
                        <div style={{ opacity: '0.6', marginBottom: '4px' }}>Image size: 650x861</div>
                        <div style={{ opacity: '0.6', marginBottom: '15px' }}>Image formats (PNG, JPEG or JPG)</div>
                        { test?.test_cover_url?.length>0 || test?.cover_image ?
                          <img src={test.cover_image?test.cover_image:test.test_cover_url} style={{width: '100px', height: '100px', margin: '0 auto 15px'}} />:''
                        }

                        { error.cover_image &&
                          <Styled.SaveErrorDiv style={{marginBottom: '15px'}}>{error.cover_image}</Styled.SaveErrorDiv>
                        }

                        <Styled.CoverImageLabel htmlFor='cover-image'>
                          <img src={uploadIcon} alt=''/>Upload Cover
                          <Styled.CoverImageInput
                            id='cover-image'
                            type='file'
                            accept='image/png, image/jpeg, image/jpg'
                            onChange={this.coverImageHandler}
                            name='cover_image'
                          />
                        </Styled.CoverImageLabel>
                      </Styled.CoverImageWrapDiv>
                      <Styled.InputErrorDiv></Styled.InputErrorDiv>
                    </Styled.InputWrap>
                    <Styled.InputWrap>
                      <Styled.InputTitleDiv>Logo Image</Styled.InputTitleDiv>
                      <Styled.CoverImageWrapDiv>
                        <div style={{ fontSize: '16px', marginBottom: '8px' }}>Upload Logo Image</div>
                        <div style={{ opacity: '0.6', marginBottom: '4px' }}>Image size: 650x861</div>
                        <div style={{ opacity: '0.6', marginBottom: '15px' }}>Image formats (PNG, JPEG, SVG or JPG)</div>

                        { test?.test_icon_img?.length>0 || test.cover_logo ?
                          <img src={test?.cover_logo? test.cover_logo: test?.test_icon_img} style={{width: '100px', height: '100px', margin: '0 auto 15px'}} />:''
                        }

                        { error.cover_logo &&
                          <Styled.SaveErrorDiv style={{marginBottom: '15px'}}>{error.cover_logo}</Styled.SaveErrorDiv>
                        }

                        <Styled.CoverImageLabel htmlFor='cover-logo'>
                          <img src={uploadIcon} alt=''/>Upload Logo
                          <Styled.CoverImageInput
                            id='cover-logo'
                            type='file'
                            accept='image/png, image/jpeg, image/jpg,image/svg'
                            onChange={this.logoHandler}
                            name='cover_logo'
                          />
                        </Styled.CoverImageLabel>
                      </Styled.CoverImageWrapDiv>
                      <Styled.InputErrorDiv></Styled.InputErrorDiv>
                    </Styled.InputWrap>
                    { typeof filter !== 'undefined' ?
                      <Styled.InputWrap>
                        <Styled.InputTitleDiv>Skill</Styled.InputTitleDiv>
                        <div style={{ display: 'flex' }}>
                          <Dropdown title="Select Skills" list={filter.category} value="id" name="master_skill_id" selected={this.dropdownChange} width="600px" height="55px" option="category_name" active={test} error={error.master_skill_id !== ''} />
                          <Styled.InputNewButton onClick={() => this.addNewItem('category')}>{newItem.category === true ? '-' : '+'}</Styled.InputNewButton>
                        </div>
                        <Styled.InputErrorDiv>{error.master_skill_id}</Styled.InputErrorDiv>
                      </Styled.InputWrap>
                    : ''
                    }
                    { newItem.category === true ?
                      <Styled.InputWrap error={error.new_category !== ''}>
                        <Styled.InputTitleDiv>Skill</Styled.InputTitleDiv>
                        <input type="text" id="new_category" placeholder="Enter Skill" value={test.new_category} onChange={(e) => this.inputChange(e)} />
                        <Styled.InputErrorDiv>{error.new_category}</Styled.InputErrorDiv>
                      </Styled.InputWrap>
                    : ''
                    }
                    { typeof filter !== 'undefined' ?
                      <Styled.InputWrap>
                        <Styled.InputTitleDiv>Instruction</Styled.InputTitleDiv>
                        <div style={{ display: 'flex' }}>
                          <Dropdown title="Select Instruction" list={filter.instruction} value="id" name="instruction_id" selected={this.dropdownChange} width="600px" height="55px" option="instruction" active={test} error={error.instruction_id !== ''} />
                          <Styled.InputNewButton onClick={() => this.addNewItem('instruction')}>{newItem.instruction === true ? '-' : '+'}</Styled.InputNewButton>
                        </div>
                        <Styled.InputErrorDiv>{error.instruction_id}</Styled.InputErrorDiv>
                      </Styled.InputWrap>
                    : ''
                    }
                    { newItem.instruction === true ?
                      <Styled.InputWrap error={error.new_instruction !== ''}>
                        <Styled.InputTitleDiv>New Instruction</Styled.InputTitleDiv>
                        <textarea rows="5" type="text" id="new_instruction" placeholder="Enter Instructions" value={test.new_instruction} onChange={(e) => this.inputChange(e)} />
                        <Styled.InputErrorDiv>{error.new_instruction}</Styled.InputErrorDiv>
                      </Styled.InputWrap>
                    : ''
                    }

                    <Styled.RowDiv style={{ padding: '0px 30px' }}>
                      <Styled.InputWrap style={{ padding: '0px 40px 0px 0px' }} error={error.duration !== ''}>
                        <Styled.InputTitleDiv>Duration (In min.)</Styled.InputTitleDiv>
                        <input type="text" id="duration" placeholder="eg; 45 min" value={test.duration} onChange={(e) => this.inputChange(e, 'digit')} style={{ width: '280px' }} />
                        <Styled.InputErrorDiv>{error.duration}</Styled.InputErrorDiv>
                      </Styled.InputWrap>

                      <Styled.InputWrap style={{ padding: '0px' }}>
                        <Styled.InputTitleDiv>Difficulty Level</Styled.InputTitleDiv>
                        <Dropdown title="Select Difficulty" list={difficulty} value="id" name="difficulty_level" selected={this.dropdownChange} width="280px" height="55px" option="title" active={test} error={error.difficulty_level !== ''} />
                        <Styled.InputErrorDiv>{error.difficulty_level}</Styled.InputErrorDiv>
                      </Styled.InputWrap>
                    </Styled.RowDiv>

                    <Styled.RowDiv style={{ padding: '0px 30px' }}>
                      <Styled.InputWrap style={{ padding: '0px 40px 0px 0px' }} error={error.total_questions !== ''}>
                        <Styled.InputTitleDiv>Total Questions</Styled.InputTitleDiv>
                        <input type="text" id="total_questions" placeholder="eg; 10" value={test.total_questions} onChange={(e) => this.inputChange(e, 'digit')} style={{ width: '280px' }} />
                        <Styled.InputErrorDiv>{error.total_questions}</Styled.InputErrorDiv>
                      </Styled.InputWrap>

                      <Styled.InputWrap style={{ padding: '0px' }} error={error.total_marks !== ''}>
                        <Styled.InputTitleDiv>Total Marks</Styled.InputTitleDiv>
                        <input type="text" id="total_marks" placeholder="eg; 100" value={test.total_marks} onChange={(e) => this.inputChange(e, 'digit')} style={{ width: '280px' }} />
                        <Styled.InputErrorDiv>{error.total_marks}</Styled.InputErrorDiv>
                      </Styled.InputWrap>
                    </Styled.RowDiv>

                    <Styled.TestSwitchDiv>
                      <Styled.SwitchLabel><input type="checkbox" id="is_pooled" checked={test.is_pooled} onChange={(e) => this.checkboxChange(e)} /><span /></Styled.SwitchLabel>
                      Select the question from pool?
                    </Styled.TestSwitchDiv>

                    {/* <Styled.TestSwitchDiv>
                      <Styled.SwitchLabel><input type="checkbox" id="is_bootcamp" checked={test.is_bootcamp} onChange={(e) => this.checkboxChange(e)} /><span /></Styled.SwitchLabel>
                      Bootcamp Assessment?
                    </Styled.TestSwitchDiv> */}

                    {/* <Styled.InputWrap style={{ margin: '20px 0px 34px 0px' }}>
                      <RadioButton list={ownerTypes} value="id" name="owners" option="title" selected={this.ownerTypeChange} width="600px" rowItemCount={4} active={test} />
                    </Styled.InputWrap> */}

                    <Styled.InputWrap>
                        <Styled.InputTitleDiv>Select Ownership</Styled.InputTitleDiv>
                        <Dropdown title={`Select Ownership`} list={ownerTypes}
                        value="id" name="owners" selected={this.ownerTypeChange}
                        width="600px" height="55px" option="title" active={test} />
                      </Styled.InputWrap>


                    { (test.owners === 'BOOTCAMP' || test.owners === 'RECRUITER') ?
                      <Styled.InputWrap>
                        <Styled.InputTitleDiv>{`${test.owners === 'BOOTCAMP' ? 'Bootcamp' : 'Recruiter'}s`}</Styled.InputTitleDiv>
                        <Dropdown title={`Select ${test.owners === 'BOOTCAMP' ? 'Bootcamp' : 'Recruiter'} Type`} list={owners && owners.data ? owners.data : []} value="id" name="owners_id" selected={this.dropdownChange} width="600px" height="55px" option="title" active={test} error={error.owners_id !== ''} />
                        <Styled.InputErrorDiv>{error.owners_id}</Styled.InputErrorDiv>
                      </Styled.InputWrap>
                    : ''
                    }

                    <Styled.DefaultLanguageWrap>
                    <div style={{display: "flex", alignItems: "center"}}>
                      <p style={{margin: 0, fontSize: "14px", lineHeight: "17px", fontWeight: "700"}}>Default languages for this assessment</p>
                    </div>

                    <Styled.DefaultLangLabelWrap>
                      {
                        defaultLanguages?.map((obj, idx) => (
                          <Styled.DefaultLanguageSwitchLabel>
                            <input type="checkbox" id={idx} checked={obj.selected} onChange={(e) => this.handleDefaultLanguage(e)} />
                            <p style={{margin: "0 0 0 10px"}}>{obj.name}</p>
                          </Styled.DefaultLanguageSwitchLabel>
                        ))
                      }
                    </Styled.DefaultLangLabelWrap>

                    </Styled.DefaultLanguageWrap>

                  </Styled.DetailsWrapDiv>
                : ''
                }

                { level === 1 ?
                  <Styled.DetailsWrapDiv>
                    <Styled.MarksWrapDiv>
                      <div>Question in Test: <strong>{`${totalQuestions}/${test.total_questions}`}</strong></div>
                      <div>Total Marks: <strong>{`${totalMarks}/${test.total_marks}`}</strong></div>
                      { test.is_pooled === true ? <button onClick={this.openPoolModal}><span>+</span>Add Question from Pool</button> : '' }
                        {questions.length===0&&this.state.filters.master_skill_id&&this.state.filters.difficulty_type&&!this.state.removeBtn&&
                         <Styled.SaveButton style={{ height: '40px',marginLeft:"20px" }} disabled={ this.state.loading} onClick={()=>this.generateQuestion(this.state.filters.difficulty_type,this.state.filters.master_skill_id)}>Generate</Styled.SaveButton>}

                    </Styled.MarksWrapDiv>

                    <Modal show={poolModalToggle} close={this.closePoolModal} heading="Add Question">
                      { typeof filter !== 'undefined' ?
                        <div style={{ display: 'flex', flexDirection: 'column', padding: '0px 30px' }}>
                          <Styled.InputWrap style={{ padding: '0px' }}>
                            <Styled.InputTitleDiv>Skills</Styled.InputTitleDiv>
                            <Dropdown title="Select Skills" list={filter.category} value="id" name="master_skill_id" selected={this.poolDropdownChange} width="600px" height="50px" option="category_name" active={addQuestion} error={errorAddQuestion.master_skill_id !== ''} />
                            <Styled.InputErrorDiv>{errorAddQuestion.master_skill_id}</Styled.InputErrorDiv>
                          </Styled.InputWrap>

                          <Styled.InputWrap style={{ padding: '0px' }}>
                            <Styled.InputTitleDiv>Topics</Styled.InputTitleDiv>
                            <Dropdown title="Select Topic" list={filter.topic} value="id" name="topic_id" selected={this.poolDropdownChange} width="600px" height="50px" option="topic_name" active={addQuestion} error={errorAddQuestion.topic_id !== ''} />
                            <Styled.InputErrorDiv>{errorAddQuestion.topic_id}</Styled.InputErrorDiv>
                          </Styled.InputWrap>

                          <Styled.InputWrap style={{ padding: '0px' }}>
                            <Styled.InputTitleDiv>Question Type</Styled.InputTitleDiv>
                            <Dropdown title="Select Question Type" list={filter.question_type} value="id" name="question_type_id" selected={this.poolDropdownChange} width="600px" height="50px" option="question_type_name" active={addQuestion} error={errorAddQuestion.question_type_id !== ''} />
                            <Styled.InputErrorDiv>{errorAddQuestion.question_type_id}</Styled.InputErrorDiv>
                          </Styled.InputWrap>

                          <Styled.InputWrap style={{ padding: '0px' }}>
                            <Styled.InputTitleDiv>Owners</Styled.InputTitleDiv>
                            <Dropdown title="Select Owner" list={this.state.owners} value="id" name="owners" selected={this.poolDropdownChange} width="600px" height="50px" option="title" active={addQuestion} error={errorAddQuestion.owners !== ''} />
                            <Styled.InputErrorDiv>{errorAddQuestion.owners}</Styled.InputErrorDiv>
                          </Styled.InputWrap>

                          <Styled.RowDiv style={{ padding: '0px' }}>
                            <Styled.InputWrap style={{ padding: '0px 40px 0px 0px' }}>
                              <Styled.InputTitleDiv>Difficulty Level</Styled.InputTitleDiv>
                              <Dropdown title="Select Difficulty" list={difficulty} value="id" name="difficulty_level" selected={this.poolDropdownChange} width="280px" height="50px" option="title" active={addQuestion} error={errorAddQuestion.difficulty_level !== ''} />
                              <Styled.InputErrorDiv>{errorAddQuestion.difficulty_level}</Styled.InputErrorDiv>
                            </Styled.InputWrap>

                            <Styled.InputWrap style={{ padding: '0px' }}>
                              <Styled.InputTitleDiv>Available Questions</Styled.InputTitleDiv>
                              <Styled.AvailableDiv>{questions ? questions.length : ''}</Styled.AvailableDiv>
                              {/* <input type="text" id="available_questions" placeholder="eg; 10" style={{ width: '280px', height: '50px' }} /> */}
                              <Styled.InputErrorDiv></Styled.InputErrorDiv>
                            </Styled.InputWrap>
                          </Styled.RowDiv>

                          <Styled.RowDiv style={{ padding: '0px' }}>
                            <Styled.InputWrap style={{ padding: '0px 40px 0px 0px' }} error={errorAddQuestion.question_count !== ''}>
                              <Styled.InputTitleDiv>No. of Question</Styled.InputTitleDiv>
                              <input type="text" id="question_count" placeholder="eg; 10" value={addQuestion.question_count} onChange={(e) => this.poolInputChange(e)} style={{ width: '280px', height: '50px' }} />
                              <Styled.InputErrorDiv>{errorAddQuestion.question_count}</Styled.InputErrorDiv>
                            </Styled.InputWrap>

                            <Styled.InputWrap style={{ padding: '0px' }} error={errorAddQuestion.marks_per_question !== ''}>
                              <Styled.InputTitleDiv>Marks</Styled.InputTitleDiv>
                              <input type="text" id="marks_per_question" placeholder="eg; 100" value={addQuestion.marks_per_question} onChange={(e) => this.poolInputChange(e)} style={{ width: '280px', height: '50px' }} />
                              <Styled.InputErrorDiv>{errorAddQuestion.marks_per_question}</Styled.InputErrorDiv>
                            </Styled.InputWrap>
                          </Styled.RowDiv>

                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Styled.ModalCheckWrapDiv style={{ margin: '0px' }} active={addQuestion.random} onClick={this.poolRandomSelect}>
                              Select question randomly
                            </Styled.ModalCheckWrapDiv>
                            <Styled.InputErrorDiv>{errorAddQuestion.same_question}</Styled.InputErrorDiv>
                          </div>

                        </div>
                      : ''
                      }

                      <Styled.ModalSaveWrap>
                        <Styled.BackButton style={{ height: '40px' }} onClick={this.closePoolModal}>Cancel</Styled.BackButton>
                        <Styled.SaveButton style={{ height: '40px' }} onClick={this.addPoolQuestion}>{`${editPoolIndex !== null ? 'Save' : 'Add'} Question`}</Styled.SaveButton>
                       {questions.length===0&&!this.state.removeBtn&&this.state.addQuestion.difficulty_level&&this.state.addQuestion.master_skill_id&&
                         <Styled.SaveButton style={{ height: '40px',marginLeft:"20px" }} disabled={ this.state.loading} onClick={()=>this.generateQuestion(this.state.addQuestion.difficulty_level,this.state.addQuestion.master_skill_id)}>Generate</Styled.SaveButton>}

                      </Styled.ModalSaveWrap>
                    </Modal>

                    { test.is_pooled === true && typeof pooledQuestionData !== 'undefined' ?
                      <div>
                        { pooledQuestionData.length > 0 ?
                          <Styled.QuestionTable>
                            <thead>
                              <tr>
                                <th>Skills</th>
                                <th>Topic</th>
                                <th>Question Type</th>
                                <th>No. of Questions</th>
                                <th>Marks</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              { pooledQuestionData.map((pool, poolIndex) => (
                                <tr>
                                  <td>{pool.category_name}</td>
                                  <td>{pool.difficulty_level}</td>
                                  <td>{pool.question_type_name}</td>
                                  <td>{pool.question_count}</td>
                                  <td>{pool.marks_per_question}</td>
                                  <td>
                                    <div>
                                      <button onClick={() => this.editPoolQuestion(poolIndex)}>
                                        <img src={editIcon} alt="edit" title="Edit Question" />
                                      </button>
                                      <button onClick={() => this.deletePoolQuestion(poolIndex)}>
                                        <img src={deleteIcon} alt="delete" title="Delete Question" />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              )) }
                            </tbody>
                          </Styled.QuestionTable>
                        :
                          <Styled.PleaseAddPoolDiv>Please Add Questions from Pool</Styled.PleaseAddPoolDiv>
                        }
                      </div>
                    :
                      <Styled.RowDiv style={{ padding: '0px 30px' }}>
                        { manualQuestionData.length > 0 ?
                          <Styled.QlistWrapDiv>
                            { manualQuestionData.map((q, qIndex) => {
                              if (qIndex === activeEdit) {
                                return (
                                  <Styled.QeditRowDiv>
                                    <Styled.QeditWrapDiv>
                                      <Styled.QeditTextDiv>{q.title}</Styled.QeditTextDiv>
                                      <Styled.QeditActionDiv>
                                        <button onClick={() => this.deleteManauQuestion(qIndex)}>Delete</button>
                                        <button onClick={this.cancelManualEdit}>Cancel</button>
                                        <button onClick={() => this.updateManualMarks(qIndex)}>Update</button>
                                      </Styled.QeditActionDiv>
                                    </Styled.QeditWrapDiv>
                                    <Styled.QeditMarkDiv>
                                      <div>Mark</div>
                                      <input type="text" value={this.state.manualMarks} onChange={this.changeManualMarks} />
                                    </Styled.QeditMarkDiv>
                                  </Styled.QeditRowDiv>
                                )
                              } else {
                                return (
                                  <Styled.QlistDiv>
                                    <Styled.QlistQuestionDiv>
                                      <div>{q.title}</div>
                                      <div>View Details</div>
                                    </Styled.QlistQuestionDiv>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                      <Styled.ManualMarksDiv>{`Marks ${q.marks}`}</Styled.ManualMarksDiv>
                                      <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Styled.QlistEditButton onClick={() => this.editManualQuestion(qIndex, q.marks)}>
                                          <img src={editIcon} alt="edit" title="Edit Marks" />
                                        </Styled.QlistEditButton>
                                        <Styled.QlistEditButton onClick={() => this.deleteManauQuestion(qIndex)}>
                                          <img src={deleteIcon} alt="delete" title="Remove From List" />
                                        </Styled.QlistEditButton>
                                      </div>
                                    </div>
                                  </Styled.QlistDiv>
                                )
                              }
                            }) }
                          </Styled.QlistWrapDiv>
                        :
                          <Styled.PleaseAddPoolDiv style={{ width: '30%', boxSizing: 'border-box', flexShrink: '0', marginRight: '30px' }}>Please Add Questions to Test</Styled.PleaseAddPoolDiv>
                        }
                        { typeof filter !== 'undefined' ?
                          <div style={{ width: '68%', display: 'flex', flexDirection: 'column', flexGrow: '1', flexShrink: '0' }}>
                            <Styled.FilterWrapDiv>
                              <Dropdown title="Skills" list={filter.category} value="id" name="master_skill_id" selected={this.filterSelect} width="115px" option="category_name" active={filters} addAll />
                              <Dropdown title="Topic" list={filter.topic} value="id" name="topic_id" selected={this.filterSelect} width="115px" option="topic_name" active={filters} addAll />
                              <Dropdown title="Difficulty" list={difficulty} value="id" name="difficulty_type" selected={this.filterSelect} width="115px" option="title" active={filters} addAll />
                              <Dropdown title="Type" list={filter.question_type} value="id" name="question_type_id" selected={this.filterSelect} width="115px" option="question_type_name" active={filters} addAll />
                              {/* <Styled.SearchDiv>
                                <img src={search} alt="search" />
                                <input type="text" placeholder="Search" />
                              </Styled.SearchDiv> */}
                            </Styled.FilterWrapDiv>
                            <Styled.QuestionTable style={{ border: '1px solid #E6E4E4' }}>
                              <thead>
                                <tr>
                                  <th>Question Title</th>
                                  <th>Skills</th>
                                  <th>Topic</th>
                                  <th>Type</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                { questionsLoading === false && questions && questions.length > 0 && questions.map((que, queIndex) => (
                                  queIndex >= ((page - 1) * entries) && queIndex < (page * entries) ?
                                    <tr>
                                      <td style={{ wordBreak: 'break-all' }}>{que.title}</td>
                                      <td>{que.category_name}</td>
                                      <td>{que.question_title}</td>
                                      <td>{que.difficulty_level}</td>
                                      <td>
                                        <div>
                                          { this.manualQuestionCheck(que.question_id) ?
                                            <Styled.MinusButton title="Delete from list" style={{ margin: '0px' }} onClick={() => this.deleteManualQuestion(que.question_id)} />
                                          :
                                            <Styled.AddButton style={{ margin: '0px' }} title="Add Question" onClick={() => this.addManualQuestion(que.question_id, que.title,que.question_type_code)} />
                                          }
                                          {/* <button>
                                            <img src={publicIcon} alt="view" title="View Question" />
                                          </button> */}
                                        </div>
                                      </td>
                                    </tr>
                                  : ''
                                )) }
                              </tbody>
                            </Styled.QuestionTable>

                            { questionsLoading === true ?
                              <Styled.NoQuestionDiv>Loading ...</Styled.NoQuestionDiv>
                            :
                              questions && questions.length === 0 ?
                                <Styled.NoQuestionDiv>No Question Found</Styled.NoQuestionDiv>
                              : ''
                            }

                            { questions && questions.length > 10 ?
                              <Pagination
                                count={questions.length}
                                entries={entries}
                                currentPage={page}
                                paginationClick={this.paginationClick}
                              />
                            : <div />
                            }
                          </div>
                        : ''
                        }

                      </Styled.RowDiv>
                    }
                  </Styled.DetailsWrapDiv>
                : ''
                }

                { level === 2 ?
                  <Styled.DetailsWrapDiv>
                    <Styled.TopBorderBoxDiv>
                      <Styled.TopBorderHeadDiv>Test Settings</Styled.TopBorderHeadDiv>
                      <Styled.WrapCheckboxDiv>
                        <label>
                          <input type="checkbox" id="attempt_all" checked={test.attempt_all} onChange={(e) => this.checkboxChange(e)}  />
                          <span />
                          Mandatory to attempt all the questions
                        </label>
                        <label>
                          <input type="checkbox" id="hop_question" checked={test.hop_question} onChange={(e) => this.checkboxChange(e)} />
                          <span />
                          All candidate to move forward and backward
                        </label>
                        <label>
                          <input type="checkbox" id="multiple_attempt" checked={test.multiple_attempt} onChange={(e) => this.checkboxChange(e)} />
                          <span />
                          Allow multiple attempt of the test by a candidate
                        </label>
                        <label>
                          <input type="checkbox" id="fullscreen" checked={test.fullscreen} onChange={(e) => this.checkboxChange(e)} />
                          <span />
                          Take test in full screen mode
                        </label>
                        <label>
                          <input type="checkbox" id="shuffle" checked={test.shuffle} onChange={(e) => this.checkboxChange(e)} />
                          <span />
                          Optionwise Shuffling
                        </label>
                      </Styled.WrapCheckboxDiv>

                      { test.multiple_attempt === true ?
                        <Styled.InputWrap style={{ padding: '15px 0px 0px 0px' }} error={error.max_attempt !== ''}>
                          <Styled.InputTitleDiv>Maximum number of attempt by a candidate</Styled.InputTitleDiv>
                          <input type="text" id="max_attempt" placeholder="Enter number of attempt" value={test.max_attempt} onChange={(e) => this.inputChange(e, 'digit')} style={{ width: '355px' }} />
                          <Styled.InputErrorDiv>{error.max_attempt}</Styled.InputErrorDiv>
                        </Styled.InputWrap>
                      : ''
                      }

                    </Styled.TopBorderBoxDiv>

                    <Styled.TopBorderBoxDiv>
                      <Styled.TopBorderHeadDiv>Security</Styled.TopBorderHeadDiv>
                      <Styled.WrapCheckboxDiv>
                        <label>
                          <input type="checkbox" id="live_screen_capture" checked={test.live_screen_capture} onChange={(e) => this.checkboxChange(e)} />
                          <span />
                          Allow live screen capture of candidate test panel
                        </label>
                        <label>
                          <input type="checkbox" id="mic_check" checked={test.mic_check} onChange={(e) => this.checkboxChange(e)} />
                          <span />
                          Allow live mic check of candidate test panel
                        </label>
                        <label>
                          <input type="checkbox" id="location_check" checked={test.location_check} onChange={(e) => this.checkboxChange(e)} />
                          <span />
                          Allow live location check of candidate test panel
                        </label>
                        <label>
                          <input type="checkbox" id="alter_msg" checked={test.alter_msg} onChange={(e) => this.checkboxChange(e)} />
                          <span />
                          Allow alter message in candidate test panel
                        </label>
                      </Styled.WrapCheckboxDiv>
                    </Styled.TopBorderBoxDiv>
                  </Styled.DetailsWrapDiv>
                : ''
                }

                { level === 3 ?
                  <Styled.DetailsWrapDiv>
                    <Styled.TopBorderBoxDiv>
                      <Styled.TopBorderHeadDiv>Schedule Test</Styled.TopBorderHeadDiv>

                      <Styled.RowDiv>
                        <Styled.InputWrap style={{ padding: '0px 40px 0px 0px' }} error={error.start_date !== ''}>
                          <Styled.InputTitleDiv>Start Date</Styled.InputTitleDiv>
                          <input type="date" id="start_date" placeholder="Start date" value={test.start_date} min={new Date().toISOString().split("T")[0]} onChange={(e) => this.inputChange(e)} style={{ width: '280px', fontFamily: 'sans-serif' }} />
                          <Styled.InputErrorDiv>{error.start_date}</Styled.InputErrorDiv>
                        </Styled.InputWrap>

                        <Styled.InputWrap style={{ padding: '0px' }} error={error.expiry_date !== ''}>
                          <Styled.InputTitleDiv>Expiry Date</Styled.InputTitleDiv>
                          <input type="date" id="expiry_date" placeholder="Expiry date" value={test.expiry_date} min={test.start_date} onChange={(e) => this.inputChange(e)} style={{ width: '280px', fontFamily: 'sans-serif' }} />
                          <Styled.InputErrorDiv>{error.expiry_date}</Styled.InputErrorDiv>
                        </Styled.InputWrap>
                      </Styled.RowDiv>

                      <Styled.WrapCheckboxDiv style={{ justifyContent: 'flex-start' }}>
                        <label style={{ width: '130px' }}>
                          <input type="radio" name="test_type" id="test_type" value="PUBLIC" checked={test.test_type === 'PUBLIC'} onChange={(e) => this.inputChange(e)} />
                          <span />
                          Public
                        </label>
                        <label style={{ width: '130px' }}>
                          <input type="radio" name="test_type" id="test_type" value="PRIVATE" checked={test.test_type === 'PRIVATE'} onChange={(e) => this.inputChange(e)} />
                          <span />
                          Private
                        </label>
                      </Styled.WrapCheckboxDiv>

                      { test.test_type === 'PRIVATE' ?
                        <Styled.InputWrap style={{ marginTop: '20px', padding: '0px' }} error={error.candidate_email !== ''}>
                          <Styled.InputTitleDiv>Email Address</Styled.InputTitleDiv>
                          <textarea rows="8" id="candidate_email" placeholder="Enter email address of the candidate" value={test.candidate_email} onChange={(e) => this.inputChange(e)} />
                          <Styled.InputErrorDiv>{error.candidate_email}</Styled.InputErrorDiv>
                        </Styled.InputWrap>
                      : ''
                      }

                    </Styled.TopBorderBoxDiv>
                  </Styled.DetailsWrapDiv>
                : ''
                }

                <Styled.SaveWrapDiv>{saveWrap}</Styled.SaveWrapDiv>

              </Styled.CardDiv>

            </Styled.ContentDiv>

            <Footer />
          </Styled.ContentWrapDiv>

        </Styled.ColumnDiv>
      </Styled.MainDiv>
    )
  }
}

const mapStateToProps = state => ({
  addAssessmentTest: state.addAssessmentTest,
  assessmentQuestion: state.assessmentQuestion,
  addAssessmentQuestion: state.addAssessmentQuestion,
})

const mapDispatchToProps = {
  addRequest,
  filterRequest,
  questionRequest,
  getRequest,
  addClear,
  ownerRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAssessmentTest)
